document.addEventListener('alpine:init', () => {
    Alpine.store('scrolled', {
        value: false,
        threshold: 50,
        hysteresis: 10,
        toggleCooldown: 200,
        lastToggleAt: 0,
        ticking: false,

        init() {
            const update = () => {
                this.ticking = false;

                const enterThreshold = this.threshold + this.hysteresis;
                const exitThreshold = Math.max(0, this.threshold - this.hysteresis);
                const now = Date.now();

                if (now - this.lastToggleAt < this.toggleCooldown) {
                    return;
                }

                if (this.value) {
                    if (window.scrollY < exitThreshold) {
                        this.value = false;
                        this.lastToggleAt = now;
                    }
                } else if (window.scrollY > enterThreshold) {
                    this.value = true;
                    this.lastToggleAt = now;
                }
            };

            const onScroll = () => {
                if (!this.ticking) {
                    this.ticking = true;
                    window.requestAnimationFrame(update);
                }
            };

            window.addEventListener('scroll', onScroll, { passive: true });
            update();
        }
    });

    Alpine.store('disableScroll', {
        requests: [],
        scrollbarWidth: 0,

        init() {
        },

        get active() {
            return this.requests.length > 0;
        },

        add(id) {
            if (!this.requests.includes(id)) {
                this.requests.push(id);
                this.updateBody();
            }
        },

        remove(id) {
            this.requests = this.requests.filter(request => request !== id);
            this.updateBody();
        },

        updateBody() {
            const body = document.body;
            const html = document.documentElement;

            if (this.active) {
                if (!html.classList.contains('overflow-hidden')) {
                    this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
                    
                    html.classList.add('overflow-hidden');
                    
                    if (this.scrollbarWidth > 0) {
                        body.style.paddingRight = `${this.scrollbarWidth}px`;
                    }
                }
            } else {
                html.classList.remove('overflow-hidden');
                body.style.paddingRight = '';
            }
        }
    });

    Alpine.data('header', () => ({
        openMenu: null,

        openDropdown(name) {
            this.openMenu = name;
        },

        closeDropdown() {
            this.openMenu = null;
        },

        init() {
            // Header component initialized
        },

        destroy() {
            // Cleanup if needed
        },
    }));
});
